/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { UnifiedCitationModule } from '@coursera-web/cds-labs';

import type { PromoTemplateCitationFragment } from 'bundles/promo-template/__generated__/contentfulTypes';

type Props = {
  content: PromoTemplateCitationFragment;
};

const styles = {
  // This helps space the Footer border which is noticable for non-white backgrounds.
  divWrapper: css`
    margin-bottom: var(--cds-spacing-200);
  `,
};

function CitationModule({ content }: Props) {
  if (!content || !content?.citations) return null;

  const { citations } = content;

  // Wrapped in a div to remove the side effects of negative margins of the grids.
  return (
    <div css={styles.divWrapper}>
      <UnifiedCitationModule {...content} removeBottomPadding removeTopPadding citations={citations} />
    </div>
  );
}

export { CitationModule };

export type { Props };

export default CitationModule;
